"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _normalizeFormat = require("../../utils/normalizeFormat");
var _DebounceHook = _interopRequireDefault(require("../DebounceHook"));
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
var _BrixelInputStep = _interopRequireDefault(require("../../hooks/component/BrixelInputStep"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelInputStepNumber = props => {
  const {
    className = '',
    disableDelay = false,
    disabled = false,
    fluid = false,
    formatType,
    input,
    isDisabled = false,
    label = null,
    labelLeft = null,
    large = false,
    max = 1000,
    message = {
      help: null,
      error: null
    },
    meta = {
      dirty: false,
      invalid: false
    },
    min = 0,
    modal = null,
    placeholder = '0',
    startFrom = 0,
    step = 1,
    tooltip
  } = props;
  const [currentValue, setCurrentValue] = (0, _react.useState)(input?.value || 0);
  const debouncedSearchTerm = (0, _DebounceHook.default)(currentValue, disableDelay ? 0 : 500);
  const defValue = (0, _BrixelInputStep.default)(currentValue, formatType, {
    min,
    max
  });
  (0, _react.useEffect)(() => {
    if (input?.onChange && typeof currentValue !== 'undefined' && !disableDelay) {
      input.onChange(+currentValue);
    }
  }, [debouncedSearchTerm]);
  (0, _react.useEffect)(() => {
    if (input?.onChange && typeof currentValue !== 'undefined' && disableDelay) input.onChange(+currentValue);
  }, [currentValue]);
  (0, _react.useEffect)(() => {
    if (typeof input?.value !== 'undefined' && input?.value !== currentValue) {
      setCurrentValue(input.value);
    }
  }, [input?.value]);
  const onChange = (e, action) => {
    e.preventDefault();
    if (disabled || isDisabled) return false;
    let defValueThis = +currentValue || 0;
    if ((0, _lodash.isString)(currentValue) && currentValue.includes('T')) {
      defValueThis = (0, _normalizeFormat.normalizeRooms)(currentValue);
    }
    if (action === 'dec' && +min <= defValueThis - step) {
      defValueThis -= step;
    }
    if (action === 'inc' && +max >= defValueThis + step) {
      defValueThis += step;
    }
    setCurrentValue(defValueThis);
  };
  const disabledBtn = act => {
    if (disabled || isDisabled) return true;
    let isEnabled = true;
    let curValue = currentValue;
    if ((0, _lodash.isString)(currentValue) && currentValue.includes('T')) {
      curValue = (0, _normalizeFormat.normalizeRooms)(currentValue);
    }
    if (act === 'dec') {
      if (startFrom > min && !currentValue || curValue && currentValue && +curValue > min) {
        isEnabled = true;
      } else {
        isEnabled = false;
      }
    }
    if (act === 'inc') {
      if (max && startFrom < max && !currentValue || max && curValue && +curValue < max || !max) {
        isEnabled = true;
      } else {
        isEnabled = false;
      }
    }
    return !isEnabled;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: tooltip ? 'dis-f a-c' : ''
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: `${labelLeft ? 'txtText600 mb-2 dis-b' : 'brixel-label'} ${large ? 'labelLarge' : ''}`,
    htmlFor: input?.name,
    "data-testid": "label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, label), tooltip && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "brixel-input-step jc-b a-c"
  }, labelLeft && (/*#__PURE__*/_react.default.createElement("span", {
    className: `txtText900 labelLeft ${large ? 'labelLarge' : ''}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, " ", labelLeft, " "), tooltip && !label && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: `wrap-brixel-input-step dis-f jc-b ${fluid ? 'fullWidth' : 'fixWidth'} ${labelLeft ? '' : 'bgText25 p-2'}`
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "dec notranslate",
    disabled: disabledBtn('dec'),
    onClick: e => onChange(e, 'dec'),
    type: "button",
    "data-testid": "decBtn"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: "minus"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-fix-64 p-1 fsize-500 ta-c txtText900 inputStepDisplay"
  }, defValue || defValue || defValue.toString() === '0' ? /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "result"
  }, defValue) : /*#__PURE__*/_react.default.createElement("span", {
    className: "txtText200",
    "data-testid": "result"
  }, placeholder)), /*#__PURE__*/_react.default.createElement("button", {
    className: "inc notranslate",
    disabled: disabledBtn('inc'),
    onClick: e => onChange(e, 'inc'),
    type: "button",
    "data-testid": "incBtn"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: "plus"
  })))), (message.help || meta.invalid) && (/*#__PURE__*/_react.default.createElement("span", {
    className: `message ${meta.dirty && meta.invalid ? 'error-message' : ''}`
  }, meta.dirty && meta.invalid ? message.error : message.help)), modal && (/*#__PURE__*/_react.default.createElement("span", {
    onClick: e => modal.func ? modal.func(e) : '',
    className: `message ${modal.func ? 'cur-poi' : ''} ${modal.className || ''}`,
    dangerouslySetInnerHTML: {
      __html: modal.message || ''
    }
  })));
};
var _default = exports.default = BrixelInputStepNumber;